import { css } from 'lit';

export default css`
    .selection-bar {
        position: sticky;
        top: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--metrics-spacing-xs) var(--metrics-spacing-s);
        background-color: var(--color-surface-primary);
        border-bottom: 1px solid var(--color-border-divider-light);
        font-size: var(--font-size-body-s);
        color: var(--color-text-secondary);
    }

    .selection-bar button {
        display: flex;
        align-items: center;
        gap: var(--metrics-spacing-xs);
        min-width: auto;
    }

    .fa-sharp.fa-solid {
        font: var(--fa-font-sharp-solid);
    }

    .fa-times::before {
        content: '\\f00d';
    }

    .list {
        width: 100%;
        height: 100%;
        background-color: var(--color-surface-primary);
        border-radius: var(--metrics-radius-s);
        overflow-y: auto;
    }

    @media (max-width: 768px) {
        .list {
            box-sizing: border-box;
            padding-bottom: var(--grid-10);
        }
    }

    .skeleton-container {
        padding: var(--metrics-spacing-m);
    }

    .skeleton-location {
        width: 45%;
        height: 1.1rem;
        margin: var(--metrics-spacing-l) var(--metrics-spacing-l) var(--metrics-spacing-s) var(--metrics-spacing-l);
    }

    .skeleton-entry {
        display: flex;
        gap: var(--metrics-spacing-s);
        padding: var(--metrics-spacing-xs);
        margin-bottom: var(--metrics-spacing-m);
    }

    .skeleton-icon {
        width: var(--grid-5);
        height: var(--grid-5);
        flex-shrink: 0;
    }

    .skeleton-body {
        width: 85%;
    }

    .skeleton-name {
        width: 92%;
        height: var(--metrics-spacing-l);
        margin-bottom: var(--metrics-spacing-s);
    }

    .skeleton-meta {
        display: flex;
        gap: var(--metrics-spacing-s);
    }

    .skeleton-meta > div {
        height: var(--metrics-spacing-l);
        width: 42%;
    }
`;
